import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const COMPANY_GROUP_CREATE_RESOURCE = "company-group" as const;
export const COMPANY_GROUP_CREATE_API_PATH = `/v1/${COMPANY_GROUP_CREATE_RESOURCE}` as const;

export type CompanyGroupCreateBody =
  paths[typeof COMPANY_GROUP_CREATE_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type CompanyGroupCreateResponse =
  paths[typeof COMPANY_GROUP_CREATE_API_PATH]["post"]["responses"][201]["content"]["application/json"];

export const useCompanyGroupCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<CompanyGroupCreateResponse, Error, CompanyGroupCreateBody>({
    mutationFn: async (body: CompanyGroupCreateBody) => {
      const response = await alphartisApiAxios.post<CompanyGroupCreateResponse>(COMPANY_GROUP_CREATE_API_PATH, body);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [COMPANY_GROUP_CREATE_RESOURCE],
      });
    },
  });
};
